import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=0ff03716&scoped=true&"
import script from "./ClockIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff03716",
  null
  
)

export default component.exports